import React from 'react'
import { Form, FormGroup } from 'reactstrap'
import { Field, reduxForm } from 'redux-form'
import PropTypes from 'prop-types'
import FormItem from '../../../../common/forms/FormItem'
import { isRequired, validateEndDate } from '../../../../../utils/validators'
import DatePicker from '../../../../common/forms/input/DatePicker'
import FormFooter from '../../../../common/forms/FormFooter'


const validateDate = (value, allValues) =>
  validateEndDate(value, allValues.fromDateString);


const BusWaitTimeViolationSearchForm = ({
  handleSubmit,
  loading,
}) => (
  <Form onSubmit={handleSubmit}>
    <FormGroup row>
      <FormItem label="Desde" required>
        <Field
          name="fromDateString"
          component={DatePicker}
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Hasta" required>
        <Field
          name="toDateString"
          component={DatePicker}
          validate={[isRequired, validateDate]}
        />
      </FormItem>
    </FormGroup>
    <FormFooter
      saveButtonDisabled={loading}
      saveButtonColor='secondary'
      saveButtonText='Buscar'
      saveButtonIcon='fa fa-search'
    />
  </Form>
)

BusWaitTimeViolationSearchForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
}

BusWaitTimeViolationSearchForm.defaultProps = {
  loading: false,
}

export default reduxForm({
  form: 'busWaitTimeViolationSearchForm',
})(BusWaitTimeViolationSearchForm)
